module.exports = __webpack_public_path__ + "static/media/folkekirken.86b2fb1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/folkekirken.png
// module id = 900
// module chunks = 0